export default __webpack_public_path__ + "static/media/LoudTwo.cf39008d.JPG";